import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingComponent } from './setting/setting.component';
import { IndexComponent } from './index/index.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { SumoCodeComponent } from './sumo-code/sumo-code.component';
import { TeamComponent } from './team/team.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { GoogleSearchConsoleComponent } from './google-search-console/google-search-console.component';

const routes: Routes = [
  { path: '', component: IndexComponent,title: 'Low Competition Kw Research | Strell.io ',children:[
    { path: '', component: WelcomePageComponent,title: 'Dashboard | Strell.io' },
    { path: 'settings', component: SettingComponent,title: 'Settings | Strell.io' },
    { path: 'code', component: SumoCodeComponent,title: 'Apply Code | Strell.io' },
    { path: 'team', component: TeamComponent,title: 'Team Setting | Strell.io' },
    { path: 'integration', component: IntegrationsComponent,title: 'Integrations | Strell.io' },
    { path: 'integration-gsc', component: GoogleSearchConsoleComponent,title: 'Integrations | Strell.io' },
  ] },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StrellRoutingModule { }
